import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Componente que redirige al usuario segun su rol
 * - Mercaderistas van a /mi-dia (app simplificada)
 * - Otros roles van a /dashboard
 */
export default function RoleBasedRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Mercaderistas tienen su propia app simplificada
  if (user.rol === 'mercaderista') {
    return <Navigate to="/mi-dia" replace />;
  }

  // Gerente comercial va al dashboard comercial
  if (user.rol === 'gerente_comercial') {
    return <Navigate to="/dashboard-comercial" replace />;
  }

  // Invitado (demo read-only) no tiene /dashboard — va a dashboard-comercial
  if (user.rol === 'invitado') {
    return <Navigate to="/dashboard-comercial" replace />;
  }

  // Visita INVIMA va a batch records (no tiene acceso a dashboard)
  if (user.rol === 'visita_invima') {
    return <Navigate to="/batch" replace />;
  }

  // Operarios van al dashboard
  if (user.rol === 'operario') {
    return <Navigate to="/dashboard" replace />;
  }

  // Otros roles van al dashboard (página de saludo)
  return <Navigate to="/dashboard" replace />;
}
